import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router';

/**
 * GuardedRoute - A flexible route guard component for conditional routing
 *
 * @param {boolean} canActivate - Boolean value indicating if route can be accessed
 * @param {string} redirectTo - Path to redirect to if guard fails
 * @param {object} component - Component to render if guard passes
 * @param {function} render - Render function to call if guard passes
 */
const GuardedRoute = ({ canActivate, redirectTo, component: Component, render, exact, path, ...rest }) => (
  <Route
    exact={exact}
    path={path}
    {...rest}
    render={props => {
      if (!canActivate) {
        return <Redirect to={{ pathname: redirectTo }} replace />;
      }
      if (Component) {
        return <Component {...props} />;
      }
      if (render) {
        return render(props);
      }
      return null;
    }}
  />
);

GuardedRoute.propTypes = {
  canActivate: PropTypes.bool.isRequired,
  redirectTo: PropTypes.string.isRequired,
  component: PropTypes.elementType,
  render: PropTypes.func,
  exact: PropTypes.bool,
  path: PropTypes.string.isRequired,
};

export default GuardedRoute;
